import { Component, Input, ViewChild } from '@angular/core';
import { ViewCompanyComponent } from 'components/company/viewcompany.component';
import { ButtonComponent } from 'components/input/button/button.component';
import { FileUploadComponent, UploadedFile } from 'components/input/file-upload/file-upload';
import { ListTaskflowComponent } from 'components/task/taskflow/list-taskflow.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { TaskActionType } from 'enums/TaskActionType';
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { TaskAttachmentModel } from 'models/generated/Entities.GormCrm.TaskAttachment';
import { SelectListItemModel } from 'models/SelectList';
import { Inputs } from 'modules/inputs';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { TaskService } from 'services/task.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'create-supportflow',
	templateUrl: './create-supportflow.component.html',
	providers: [FormValidationService],
	imports: [Layout, Inputs, FileUploadComponent, TranslatePipe]
})
@ComponentUrl('create-supportflow')
@CredentialRequired(CredentialType.BetaUserAccess)
export class CreateSupportflowComponent {

	private _companyId = '';

	@UrlParam
	@Input()
	set companyId(id: string) {
		if (id) {
			this._companyId = id;
			this.navigation.openNavigationView(this, 'company-related-views', ViewCompanyComponent).then(viewCompany => { viewCompany.companyId = id; });
		}
	}
	get companyId() {
		return this._companyId;
	}

	@ViewChild('saveButton') saveButton?: ButtonComponent;

	usersList: SelectListItemModel[];
	taskAreas: SelectListItemModel[] = [];
	taskActionTypeEnum = TaskActionType;

	taskActionTypeList: SelectListItemModel[] = [];
	inputTypeEnum = InputType;

	taskAction = new TaskActionModel();
	taskflowDeadline: Date | null = null;
	contactOnComplete = false;

	uploading = false;
	uploadedFiles: UploadedFile[] = [];
	constructor(
		private readonly navigation: NavigationService,
		userService: UserService,
		private readonly taskService: TaskService,
		translate: TranslatePipe) {

		this.usersList = userService.getUserSelectList();

		taskService.getAllTaskAreas().then(taskAreas => {
			for (let area of taskAreas) {
				this.taskAreas.push(new SelectListItemModel(area.id as string, translate.transform('task-area.area-name.' + area.name)));
			}
		});

		this.taskActionTypeList = taskService.getTaskActionTypes();
		this.navigation.refreshUrl();
	}

	get minDeadline(): Date | undefined {
		if (this.taskAction.plannedDate) return this.taskAction.plannedDate;
		return new Date();
	}

	changeTaskActionType(taskActionType: TaskActionType) {
		if (taskActionType == TaskActionType.contact)
			this.contactOnComplete = false;
		this.taskAction.type = taskActionType;
	}

	async saveSupportflow() {
		if (!this.companyId) return;
		const taskActions: TaskActionModel[] = [];

		this.taskAction.taskAttachments = [];
		this.uploadedFiles.forEach(file => {
			const taskAttachment = new TaskAttachmentModel();
			taskAttachment.fileReferenceId = file.fileReference!.id;
			this.taskAction.taskAttachments.push(taskAttachment);
		});
		taskActions.push(this.taskAction);

		if (this.contactOnComplete) {
			const contactTaskAction = new TaskActionModel();
			contactTaskAction.step = 1;
			contactTaskAction.taskAreaId = this.taskAction.taskAreaId;
			contactTaskAction.type = TaskActionType.contact;
			taskActions.push(contactTaskAction);
		}

		this.taskAction.include(ta => ta.taskAttachments);
		try {
			const taskFlow = await this.taskService.createTaskflowFromTag('supportflow', this.companyId, taskActions, this.taskflowDeadline);
			const view = await this.navigation.refreshView(ListTaskflowComponent);
			view.companyId = this.companyId;
			if (taskFlow.id) view.selectTaskflow(taskFlow.id);
		}
		catch {
			this.saveButton?.reset();
		}
	}
}
